<header>
  <div class="logo">
    <img src="../../../../../assets/hc/sos/upload-external-files-logo.svg" alt="" />
  </div>
</header>
<main>
  <router-outlet></router-outlet>
</main>
